import React, { useCallback } from "react";
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { Caption, Title } from "./Texts";

export default function MethodesContactMonSisra() {
	const dispatch = useAppDispatch();

	const onRadioSelected = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					msContactTeleExpertiseOnly: e.target.value === "true",
				})
			);
		},
		[dispatch]
	);
	const { preferences } = useAppSelector((s) => s.expertise);

	if (!preferences) return null;

	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={"Méthodes de contact via MonSisra"} />
			</Grid>
			<Grid item>
				<Caption
					text={
						"MonSisra permet de créer des conversations classiques entre plusieurs professionnels de santé, ou bien de créer une demande d'expertise" +
						" guidée entre un demandeur et un expert ou groupe d'experts. En tant qu'expert, vous avez la possibilité d'accepter, ou non, la création " +
						"de conversations classiques."
					}
				/>
			</Grid>
			<Grid item>
				<FormControl component="fieldset">
					<RadioGroup value={preferences.msContactTeleExpertiseOnly + ""} onChange={onRadioSelected} name="radio-buttons-group">
						<FormControlLabel
							value={"false"}
							control={<Radio  id={"ms-contact-all"}/>}
							label={
								<Grid container alignItems={"center"} spacing={0.5}>
									<Grid item>Je souhaite pouvoir être contacté librement via une conversation MonSisra ou une Téléexpertise</Grid>
								</Grid>
							}
						/>
						<FormControlLabel
							value={"true"}
							control={<Radio id={'ms-contact-teleexpertise'}/>}
							label={
								<Grid container alignItems={"center"} spacing={0.5} >
									<Grid item>Je souhaite imposer le mode Téléexpertise à tous les utilisateurs qui me contactent via MonSisra</Grid>
								</Grid>
							}
						/>
					</RadioGroup>
				</FormControl>
			</Grid>
		</Grid>
	);
}
